/** Grid column span (1–6) for direct children of `.cms-form-page__fields`. */
export type CmsColSpan = 1 | 2 | 3 | 4 | 5 | 6;

/** Returns `cms-col-span-N` for grid layout utilities, or undefined when omitted. */
export function cmsColSpanClass(span?: CmsColSpan): string | undefined {
  return span != null ? `cms-col-span-${span}` : undefined;
}
